
export const pageTitleMap : { [key: string]: any } = {
    login: '登录'
    ,member: '成员页面'
    ,timer: '学习计时'
    ,mistake: '错题本'
    ,practice: '做题记录'
    ,profile: '个人中心'
}
